import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'

export const StartAuthWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  background: ${Colors.White};
  align-items: center;
  width: 100%;

  ${Media.AboveTablet`
    margin-top: 80px;

  `}

  ${Media.Tablet`
    height: 80vh;

  `}
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: ${Colors.White};
  width: 100%;
  height: 100%;
  height: 100vh;
  height: 100svh;
`

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex: 1;

  margin: 0;

  ${Media.AboveTablet`
    min-height: 504px;
  `}
`

export const VideoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`
export const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 100vh;
  align-content: center;
  align-items: center;
`
